import React from 'react'
import { connect } from 'react-redux'
import { StyledSection } from './mSuccessMessage.style'
import { fireCtaIsClicked } from 'form/services'
import {
  Breakpoints,
  Layout,
  Container,
  ContainerPadding,
  LayoutRowGap,
  Text,
  TextColor,
  TextAppearance,
  ButtonLink,
  ButtonAppearance,
  Richtext,
  ContainerGutter
} from '@volkswagen-onehub/components-core'

const SuccessMessage = ({ header, description, ctas }) => (
  <StyledSection>
    <Container
      padding={{
        top: {
          [Breakpoints.default]: ContainerPadding.static500,
          [Breakpoints.tablet]: ContainerPadding.static500
        },
        bottom: {
          [Breakpoints.default]: ContainerPadding.static500,
          [Breakpoints.tablet]: ContainerPadding.static500
        }
      }}
    >
      <Layout
        rowGap={LayoutRowGap.static300}
        appearance={{
          [Breakpoints.default]: [
            { name: 'a', columns: 24 },
            { name: 'b', columns: 24 }
          ]
        }}
      >
        <Text
          tag="h1"
          color={TextColor.primary}
          appearance={TextAppearance.headline300}
        >
          {header}
        </Text>
        <Richtext color={TextColor.primary} markdown={description} />
      </Layout>
    </Container>
    <Container
      padding={{
        bottom: {
          [Breakpoints.default]: ContainerPadding.static500,
          [Breakpoints.tablet]: ContainerPadding.static550
        }
      }}
    >
      <Layout
        appearance={{
          [Breakpoints.default]: [
            { name: 'a', columns: 24 },
            { name: 'b', columns: 24 }
          ],
          [Breakpoints.tablet]: [
            { name: 'a', columns: 12 },
            { name: 'b', columns: 12 }
          ]
        }}
      >
        {ctas &&
          ctas.map((cta, index) => {
            return (
              <Container
                key={index}
                gutter={ContainerGutter.static100}
                padding={ContainerPadding.static200}
                stretchContent
              >
                <ButtonLink
                  appearance={ButtonAppearance.Secondary}
                  href={cta.url}
                  target={cta.target}
                  onClick={e => fireCtaIsClicked(cta.copy, cta.url, cta.target)}
                  stretchContent
                >
                  <Text
                    color={TextColor.inherit}
                    appearance={TextAppearance.copy150}
                  >
                    {cta.copy}
                  </Text>
                </ButtonLink>
              </Container>
            )
          })}
      </Layout>
    </Container>
  </StyledSection>
)

const mapStateToProps = ({ page: { cmsdata } }) => {
  const { success } = cmsdata.data.pages.homePage
  const { header, description, ctas } = success

  return {
    header,
    description,
    ctas
  }
}

export default connect(mapStateToProps)(SuccessMessage)
